<template>
  <section class="section conversion-section cta-hire bg-gray ibcgp-conversion" style="padding: 56px 0 !important">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <h2 class="mb-3">
            Afiliação gratuita e atendimento institucional
          </h2>
          <p class="mb-4 text-muted">
            Entre em contato para afiliar o município, solicitar esclarecimentos ou alinhar uma demonstração
            das soluções com a sua equipe.
          </p>
          <div class="conversion-ctas">
            <a :href="links.contatoAfiliacao" class="ibcgp-btn-solid d-inline-block mr-md-2 mb-2 mb-md-0">
              Afiliar meu município
            </a>
            <a :href="links.contatoDemonstracao" class="btn btn-outline-primary mb-2 mb-md-0 px-4 py-2">
              Falar sobre demonstração
            </a>
          </div>
          <p class="mt-4 mb-0 small">
            <a :href="links.contato">Outros assuntos — página de contato</a>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import links from '../../../consts/links.js'

export default {
  name: 'ConversionSection',
  data () {
    return { links }
  }
}
</script>

<style scoped>
.conversion-section h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #02225b;
}

.ibcgp-conversion a:not(.btn) {
  color: #2e7eed;
  font-weight: 600;
}
</style>
